import { PopUpManager, WizCommand, WizPopUp, WizEvent } from "@wizeoo/akm-component-lib";
import { CmdErrorPop } from "./cmderror.pop";

/**
 * affichage des erreurs de service
 */
export class CmdErrorMessage {
  
  /** l'instance de PopUp */
  private static CmdErrorMessagePop: WizPopUp;

  /**
   * mise à jour du jeu de message
   * @param kind type d'événement (ci-dessus)
   * @param dto DataLoadObj
   * @param scen string sur compute
   */
  public static doMessage(e: WizEvent): void { 
   
    let cmd: WizCommand<any> = e.value;
    console.log('err message', cmd.error);
    
    if (!PopUpManager.exist(this.CmdErrorMessagePop)) {
      const targetPosition: any = { right: '0px', bottom: '50px' }; // position physique
      this.CmdErrorMessagePop = new WizPopUp( 
        CmdErrorPop,
        false,
        false,
        null,
        '450px', // 350px',
        '200px', // calc(100% - 81px)',
        cmd, // params
        null,
        targetPosition
      ).show();
    }
  }

}
